import { Symbol } from './context'

const { toStringTag: contextSymbolToStringTag } = Symbol
export default contextSymbolToStringTag
